<div
  class="select"
  id="shared-select-container"
  [ngStyle]="getStyle()"
  [ngClass]="{
    'custom-error': hasCustomError,
    'select-disabled': isDisabled,
    transparent: isTransparentSelect,
    'filter-select': isFilterSelect,
    'select-disabled-no-border': isDisabled && selectNoBorder,
    'select-thin-border': isThinBorder
  }"
>
  <mat-select
    [placeholder]="defaultValue?.value! || placeholder | translate"
    [formControl]="dataControl"
    [disabled]="isDisabled"
    [required]="isRequired"
    [panelClass]="singleSelectPanelClass"
    disableOptionCentering
    id="mat-select"
    (change)="onChangeValue()"
    [(ngModel)]="defaultValue"
    (selectionChange)="onSelectionChange($event.value)"
    [class.mat-select-success]="
      !dataControl.touched || dataControl.value || !this.isRequired
    "
    [class.mat-select-error]="
      this.isRequired && dataControl.touched && dataControl.value === ''
    "
    [ngClass]="customMatSelectTextClass"
  >
    <mat-select-trigger id="mat-select-trigger" class="mat-select-trigger">
      {{ defaultValue?.value! | translate }}
    </mat-select-trigger>
    <div class="single-select-options" id="single-select-options">
      <mat-option
        class="mat-option-select"
        *ngFor="let val of data; let ind = index"
        [value]="val"
        [id]="'shared-select-mat-option-' + ind"
      >
        <span
          class="mat-option-select-container"
          [id]="'mat-option-select-container-' + ind"
        >
          <span [id]="'mat-option-text-' + ind" [class]="singleSelectTextClass">{{
            val.value | translate
          }}</span>
          <app-icon
            class="check-icon"
            id="check-icon"
            name="check"
            size="1em"
            *ngIf="showIcon && selectedValue === val.value"
          ></app-icon>
        </span>
      </mat-option>
    </div>
  </mat-select>
</div>
<mat-error
  *ngIf="this.isRequired && dataControl.touched && dataControl.value === ''"
  id="shared-select-mat-error"
  >{{ 'select.error' | translate }}</mat-error
>

<mat-error *ngIf="hasCustomError" id="mat-select-custom-error">
  <app-text
    [textStyleType]="'caption'"
    class="red-color"
    id="mat-select-custom-error-message"
    >{{ customErrorMsg }}</app-text
  >
</mat-error>
